import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=57c5eef1&scoped=true&"
import script from "./ArticleForm.vue?vue&type=script&lang=js&"
export * from "./ArticleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5eef1",
  null
  
)

export default component.exports